import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Avatar, Space } from "antd";
import { StarFilled, UserOutlined } from "@ant-design/icons";
import { baseImageUrl } from "Common/Components/baseImageUrl";
const { Text, Paragraph } = Typography;
const WelcomeSection = ({ darkMode, mentor, learnerCount, performanceRating }) => {
  const rating = Number(performanceRating) || 0;
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const theme = {
    bg: darkMode ? "#1f1f1f" : "#fff",
    border: darkMode ? "#303030" : "#f0f0f0",
    text: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    secondaryText: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    avatarBorder: darkMode ? "#9A6B0E" : "#B17F14"
  };
  return (
    <Card
      style={{
        borderRadius: 8,
        marginBottom: 12,
        backgroundColor: theme.bg,
        borderColor: theme.border,
        padding: '12px',
        display: 'flex',
        alignItems: 'center'
      }}
      variant="borderless"
      styles={{ body: { padding: 0, display: 'flex', width: '100%' } }}
    >
      <div style={{ flex: 1, marginRight: 12 }}>
        <Text strong style={{
          color: theme.text,
          fontSize: '18px',
          display: 'block',
          marginBottom: 4
        }}>
          Welcome back, {mentor?.firstName}!
        </Text>
        <Paragraph style={{
          color: theme.secondaryText,
          marginBottom: 6,
          fontSize: '15px'
        }}>
          Mentoring <strong>{learnerCount}</strong> learners
        </Paragraph>
        <Space size={4} align="center">
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Rating: {rating.toFixed(1)}/5
          </Text>
          {[...Array(fullStars)].map((_, i) => (
            <StarFilled key={`star-${i}`} style={{ color: 'gold', fontSize: '12px' }} />
          ))}
          {hasHalfStar && (
            <StarFilled style={{ color: 'gold', fontSize: '12px', opacity: 0.5 }} />
          )}
        </Space>
      </div>
    </Card>
  );
};
WelcomeSection.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  mentor: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
  performanceRating: PropTypes.number.isRequired,
  learnerCount: PropTypes.number.isRequired,
};
export default WelcomeSection;
